module.exports = __webpack_public_path__ + "static/media/ic-add-2-d-floorplan.9679f1f2.svg";